import { api } from "../api";

export interface PatronListItem {
  id: string;
  membershipId: string;
  userId: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  emailVerified: boolean;
  joinedAt: string;
  patronType: { id: string; name: string } | null;
  homeBranch: { id: string; name: string; code: string } | null;
  registeredAtBranch: { id: string; name: string; code: string } | null;
  libraryCardNumber: string | null;
  libraryCardStatus: string | null;
  patronAccountStatus: string;
}

export interface ListPatronsParams {
  q?: string;
  patronTypeId?: string;
  homeBranchId?: string;
  page?: number;
  limit?: number;
  sortBy?: "joinedAt" | "email" | "name";
  sortOrder?: "asc" | "desc";
}

export interface ListPatronsResult {
  data: PatronListItem[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const patronsApi = {
  list: (params?: ListPatronsParams) =>
    api
      .get<ListPatronsResult>("patrons", {
        params: {
          q: params?.q,
          patronTypeId: params?.patronTypeId,
          homeBranchId: params?.homeBranchId,
          page: params?.page,
          limit: params?.limit,
          sortBy: params?.sortBy,
          sortOrder: params?.sortOrder,
        },
      })
      .then((r) => r.data),

  updateMembership: (
    membershipId: string,
    data: { patronTypeId?: string | null; homeBranchId?: string | null }
  ) => api.patch(`patrons/membership/${membershipId}`, data).then((r) => r.data),

  get: (userId: string) => api.get(`patrons/${userId}`).then((r) => r.data),

  updateProfile: (
    userId: string,
    data: { firstName?: string; lastName?: string; phone?: string | null }
  ) => api.patch(`patrons/${userId}`, data).then((r) => r.data),

  suspend: (userId: string) => api.post(`patrons/${userId}/suspend`).then((r) => r.data),

  activate: (userId: string) => api.post(`patrons/${userId}/activate`).then((r) => r.data),

  auditLogs: (userId: string) => api.get(`patrons/${userId}/audit-logs`).then((r) => r.data),

  setAutoRenewalOverride: (membershipId: string, autoRenewalOverride: boolean | null) =>
    api
      .patch(`patrons/membership/${membershipId}/auto-renewal`, { autoRenewalOverride })
      .then((r) => r.data),

  sendMessage: (
    userId: string,
    body: { subject: string; content: string; dualChannel?: boolean }
  ) => api.post(`patrons/${userId}/message`, body).then((r) => r.data),
};
